import React from 'react'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import AceEditor from 'react-ace'
import { Tweet } from 'react-twitter-widgets'

import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-github'
import 'ace-builds/src-noconflict/ext-language_tools'

const selector = formValueSelector('widget')

export const ThreadVentureInput = ({ input }) => {
  return (
    <div>
      <ul className='br-dm-attachments__requirements'>
        <li>Paste ThreadVenture JSON export provided by client</li>
      </ul>

      <AceEditor
        mode='json'
        theme='github'
        onChange={input.onChange}
        editorProps={{ $blockScrolling: true }}
        value={input.value}
        width='100%'
        height='200px'
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2
        }}
      />
    </div>
  )
}

ThreadVentureInput.propTypes = {
  input: PropTypes.any
}

export const ThreadVentureContainer = ({ children }) => (
  <div className='form-group darkPanel'>
    <div className='col-md-12'>
      <div className='portlet light'>
        <div className='portlet-title'>
          <div className='caption'>
            <span className='caption-subject bold font-green-haze uppercase'>
              <i
                className='glyphicon glyphicon-check hidden-xs'
                style={{
                  alignSelf: 'flex-start',
                  marginTop: 8,
                  marginRight: 8
                }}
              />
              Configure ThreadVenture
            </span>
          </div>
        </div>
        <div className='portlet-body'>{children}</div>
      </div>
    </div>
  </div>
)

ThreadVentureContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

let ConfigureThreadVenture = ({ threadVentureExport, processedTweets }) => {
  console.log('THESE ARE THE PROCESSED TWEETS', processedTweets)
  return (
    <ThreadVentureContainer>
      <div>
        <Field
          component={ThreadVentureInput}
          name='threadVentureExport'
          value={threadVentureExport}
        />
      </div>
      <div>
        {processedTweets && processedTweets.length > 0 && (
          <div className='caption'>
            <span className='caption-subject bold font-green-haze uppercase'>
              <i
                className='glyphicon glyphicon-check hidden-xs'
                style={{
                  alignSelf: 'flex-start',
                  marginTop: 8,
                  marginRight: 8
                }}
              />
              Processed Tweets in order posted
            </span>
          </div>
        )}
        {processedTweets &&
          processedTweets.length > 0 &&
          processedTweets.map(tweet => {
            return <Tweet key={tweet.tweetId} tweetId={tweet.tweetId} />
          })}
      </div>
    </ThreadVentureContainer>
  )
}

ConfigureThreadVenture.propTypes = {
  threadVentureExport: PropTypes.string,
  processedTweets: PropTypes.array
}

ConfigureThreadVenture = reduxForm({
  form: 'widget'
})(ConfigureThreadVenture)

const ConfigureThreadVentureWithActions = connect(state => ({
  threadVentureExport: selector(state, 'threadVentureExport'),
  processedTweets: selector(state, 'processedTweets')
}))(ConfigureThreadVenture)

export default ConfigureThreadVentureWithActions



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-threadventure/index.js